import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  public type = 'password';

  constructor(
    public authService: AuthService,
    public dataService: DataService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.authService.signOut();
   }

  ngOnInit(): void { }

  public signInWithGoogle(): void {
    try {
      this.authService.googleAuth()
    } catch(e) {
      this.dataService.somethingWentWrong(e, 'Algo salió mal. Intenta de nuevo ó entra manualmente')
    }
  }

    public onViewPassword(): void {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

}
